"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/navigation";
import { ArrowRight } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export interface MidCtaProps {
	translationNamespace?: string;
	titleKey?: string;
	descriptionKey?: string;
	buttonTextKey?: string;
	buttonHref?: string;
	className?: string;
}

export default function MidCta({
	translationNamespace = "midCta",
	titleKey = "title",
	descriptionKey = "description",
	buttonTextKey = "buttonText",
	buttonHref = "/upload",
	className,
}: MidCtaProps) {
	const t = useTranslations(translationNamespace);

	return (
		<section className={cn("from-mainColor w-full bg-gradient-to-r to-themePrimary400 py-8 sm:py-10 md:py-12 lg:py-16", className)}>
			<div className="container">
				<div className="mx-auto max-w-6xl text-center">
					{/* 标题 */}
					<h2 className="mb-3 text-2xl font-bold leading-tight text-white sm:mb-4 sm:text-[30px] md:text-4xl">
						{t(titleKey)}
					</h2>

					{/* 描述 */}
					<p className="mb-8 text-sm leading-relaxed text-white md:text-base">{t(descriptionKey)}</p>

					{/* 按钮 */}
					<Link
						href={buttonHref}
						className="inline-flex items-center gap-2 rounded border-2 border-white bg-white px-6 py-3 text-sm font-semibold text-gray-900 transition-all duration-300 hover:bg-transparent hover:text-white sm:px-8 sm:py-3.5 sm:text-base"
					>
						{t(buttonTextKey)}
						<ArrowRight size={18} weight="bold" />
					</Link>
				</div>
			</div>
		</section>
	);
}
